import axios from 'axios';

const pathname = window.location.pathname;
const RecadStage = pathname.includes('ex-guard') ? (
    localStorage.recadStageExGuard || process.env.MIX_RECAD_EXGUARD_CURRENT_STAGE
): (
    localStorage.recadStage || process.env.MIX_RECAD_CURRENT_STAGE
);

const api = axios.create({
    baseURL: `${process.env.MIX_API_URL}/admin`,
    headers: { RecadStage }
});

export const apiRecad = axios.create({
    baseURL: `${process.env.MIX_API_URL}/re-cadastramento`
});

export const apiRecadExGuard = axios.create({
    baseURL: `${process.env.MIX_API_URL}/re-cadastramento-ex-guarda`
});

export const apiRoot = axios.create({
    baseURL: `${process.env.MIX_API_URL}`
});

export default api;


// WEBPACK FOOTER //
// ./resources/assets/js/services/api.js